import React from "react";

interface VoiceConversationIconProps {
    className?: string;
    color?: string;
    size?: "sm" | "md" | "lg" | "xl";
}

export const VoiceConversationIcon = ({
                                          className = "",
                                          color = "currentColor",
                                          size = "md",
                                      }: VoiceConversationIconProps) => {
    const sizeClasses = {
        sm: "w-7 h-7",
        md: "w-8 h-8",
        lg: "w-9 h-9",
        xl: "w-10 h-10",
    };

    return (
        <div className="icon voice-conversation-icon">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                className={`${sizeClasses[size]} ${className}`}
                aria-hidden="true"
            >
                <path d="M4 9v6" />
                <path d="M8 5.5v13" />
                <path d="M12 8v8" />
                <path d="M16 6.5v11" />
                <path d="M20 9.5v5" />
            </svg>
        </div>
    );
};

export default VoiceConversationIcon;
